// extracted by mini-css-extract-plugin
export default {"locked":"common_locked__nPZFp","unlocked":"common_unlocked__8drxC"};